import { NumericAspect, RangeAspect } from "@/models/HomePageSearchResponse";
import RangeSelect from "./RangeSelect";
import AspectMenu from "./AspectMenu";
import { Box, Typography } from "@mui/material";
import { AspectDivider } from "./AspectDivider";

// AJB: need an apply button to close the menu?
export default function AspectRangeMenu({
  aspectKey,
  aspectLabel,
  options,
  value,
  onChange,
  icon,
}: {
  aspectKey: string;
  aspectLabel: string;
  options: NumericAspect[];
  value: RangeAspect;
  onChange: (value: RangeAspect) => void;
  icon: React.ReactNode;
}) {
  const isSelected = value.min > -1 || value.max > -1;

  return (
    <>
      {options.length > 0 && (
        <>
          <AspectDivider />
          <AspectMenu
            label={
              // AJB: use the friendlier text like "under $1000" when
              aspectLabel
            }
            icon={icon}
            selectedValues={
              isSelected
                ? [
                    `${options.find((x) => x.value === value.min)?.label || "Min"} - ${
                      options.find((x) => x.value === value.max)?.label || "Max"
                    }`,
                  ]
                : undefined
            }
            onClear={() => {
              onChange({ min: -1, max: -1 });
            }}
            body={() => {
              return (
                <Box
                  sx={{
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Typography variant="h6">{aspectLabel}</Typography>
                  <RangeSelect
                    aspectKey={aspectKey}
                    options={options}
                    value={value}
                    onChange={onChange}
                  />
                </Box>
              );
            }}
          />
        </>
      )}
    </>
  );
}
